import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isAuthenticateAction } from "../../utils/auth";
import { updateVisitorProfile, readVisitorProfile, requestIdentity } from "../../actions"; // clear visitor data when we think the user is signed in

var shouldClearData = function shouldClearData(action) {
  return isAuthenticateAction(action) || action.type === requestIdentity.SUCCESS_TYPE;
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      _action$meta = action.meta,
      meta = _action$meta === void 0 ? {} : _action$meta,
      payload = action.payload;
  if (shouldClearData(action)) return {};

  switch (type) {
    case readVisitorProfile.SUCCESS_TYPE:
    case updateVisitorProfile.SUCCESS_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, meta.profileType, _get(payload, 'item')));

    default:
      return state;
  }
});